import * as dat from 'dat.gui'
import { Vector3 } from 'three';
const isProduction = process.env.NODE_ENV === 'production'

const gui = new dat.GUI()
if (isProduction) {
  gui.hide()
}
const modelGuiFolder = gui.addFolder('model');
const cameraGuiFolder = gui.addFolder('camera');
const lightsGuiFolder = gui.addFolder('directional light');

const settings = {
  lookAtModel: false
}
const defaultPosition = new Vector3()
let lookAtTarget = defaultPosition;

const addModelDebug = (model) => {
  modelGuiFolder.add(model.position, 'x').min(-8).max(8).step(.001)
  modelGuiFolder.add(model.position, 'y').min(-8).max(8).step(.001)
  modelGuiFolder.add(model.position, 'z').min(-8).max(8).step(.001)

  return modelGuiFolder;
}

const addDirectionalLightDebug = (light) => {
  lightsGuiFolder.add(light.position, 'x').min(-10).max(10).step(.001)
  lightsGuiFolder.add(light.position, 'y').min(-10).max(10).step(.001)
  lightsGuiFolder.add(light.position, 'z').min(-10).max(10).step(.001)

  return lightsGuiFolder;
}

const addCameraDebug = (camera, targetPosition) => {
  cameraGuiFolder.add(camera.position, 'x').min(-8).max(8).step(.001)
  cameraGuiFolder.add(camera.position, 'y').min(-8).max(8).step(.001)
  cameraGuiFolder.add(camera.position, 'z').min(-8).max(8).step(.001)

  lookAtTarget = targetPosition

  cameraGuiFolder.add(settings, 'lookAtModel').listen().onChange((val) => {
    if (val) {
      lookAtTarget = targetPosition

    } else {
      lookAtTarget = defaultPosition
    }
    // camera.lookAt(lookAtTarget);
  })

  return cameraGuiFolder;
}

export {
  addModelDebug,
  addDirectionalLightDebug,
  addCameraDebug,
  lookAtTarget,
  gui
}